import determineInterestRates from "./determine_interest_rates";

export const getInterestRates = (savingsArr, savingInterestRates) => {
    for (let i=0; i<savingsArr.length; i++){
        const savingsType = savingsArr[i].savingsType;
        if (savingInterestRates.length > 0){
            const intIndx = savingInterestRates.findIndex(elem => elem.savingsType === savingsType);
            if (intIndx === -1){
                const interestRate = determineInterestRates(savingsType);
                const intRateObj = {savingsType: savingsType, intRate: interestRate};
                savingInterestRates.push(intRateObj);
            }
        }else{
            const interestRate = determineInterestRates(savingsType);
            const intRateObj = {savingsType: savingsType, intRate: interestRate};
            savingInterestRates.push(intRateObj);
        }
    }
    return savingInterestRates;
}
export default getInterestRates;